import api, {EnrollClasses} from '../../plugins/api'

/* eslint-disable no-unused-vars */

export default {
  namespaced: true,
  state: {filterParams: {}, items: [], count: 0},
  actions: {
    async fetchItems({commit, state}, params = {}) {
      const filterParams = {...state.filterParams, ...params}
      const items = await api.EnrollClasses.fetch({isListing: true, ...filterParams})
      commit('changeState', {filterParams, items})
    },
    async countItems({commit, state}, params = {}) {
      const {_sort, populates, ...filterParams} = {...state.filterParams, ...params}
      const count = await api.EnrollClasses.count({...filterParams})
      commit('changeState', {count})
    },
    createItem(_, params = {}) {
      return EnrollClasses.create(params)
    },
    updateItem(_, {id, ...params}) {
      return EnrollClasses.update(id, params)
    },
    removeItem(_, id) {
      return EnrollClasses.remove(id)
    },
    countIndependent(_, params = {}) {
      return EnrollClasses.count(params)
    },
  },
  getters: {
    items: state => state.items,
    count: state => state.count,
    filterParams: state => state.filterParams,
  },
}
